import { LegacyEpisodePlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { getEpisodeOtt } from './get-episode-ott';

export function getEpisodeOnlineStreams(
    episode: LegacyEpisodePlayerBaseInfoContent | undefined | null
) {
    const ott = episode && getEpisodeOtt(episode);

    return ott?.onlineStreams || undefined;
}
